import { render, staticRenderFns } from "./RunPayroll.vue?vue&type=template&id=20fd71fa&"
import script from "./RunPayroll.vue?vue&type=script&lang=js&"
export * from "./RunPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports